import { render, staticRenderFns } from "./tag_maintain.vue?vue&type=template&id=1979ce22&scoped=true"
import script from "./tag_maintain.vue?vue&type=script&lang=js"
export * from "./tag_maintain.vue?vue&type=script&lang=js"
import style0 from "./tag_maintain.vue?vue&type=style&index=0&id=1979ce22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979ce22",
  null
  
)

export default component.exports